import { resolve } from 'path';

export const module = {
  load: (ns, lng) => {
    return import(`../locales/${lng}/${ns}.json`);
  },
  getFilepath: (ns, lng) => {
    return resolve(__dirname, '..', 'locales', lng, ns);
  },
  namespaces: ['sideMenu', 'loginWith2FARecomendation', 'sidenavlinks', 'sidenav'],
};
